import augmenters from './augmenters';

export default function augment(obj) {
	if (!augmenters.size) return obj;

	return [...augmenters].reduceRight((acc, val) => val(acc), obj);
}
